import useAuth from "./useAuth";

const API = `${process.env.REACT_APP_DOCUMENTS_URL}/files`;
const QUERY = `${process.env.REACT_APP_DOCUMENTS_QUERY}`.replaceAll("\"", "");

const documentsMap = {
  buyer: [
    {
      groupName: 'Operational documents',
      documents: [
        {
          key: 'Head Agreement for the provision of ORAMS (EXECUTED VERSION)',
          name: 'EXECUTION VERSION - Head Agreement for the provision of ORAMS.pdf',
          text: 'Head Agreement for the provision of ORAMS (EXECUTED VERSION)'
        },
        {
          key: 'Application of the Head Agreement - Questions and Answers for providers and agencies',
          name: 'Questions and Answers on the ORAMS Head Agreement.docx',
          text: 'Application of the Head Agreement - Questions and Answers for providers and agencies'
        },
        {
          key: 'ORAMS Service Requirements',
          name: 'Service Requirements .pdf',
          text: 'ORAMS Service Requirements'
        },
        {
          key: 'Universal Operations Manual',
          name: 'UOM Manual WORD FINAL.docx',
          text: 'Universal Operations Manual'
        },
        {
          key: 'Work Order for Rehabilitation services',
          name: 'Work Order - Rehabilitation Services.docx',
          text: 'Work Order for Rehabilitation services'
        },
        {
          key: 'Work Order for Medical services',
          name: 'Work Order - Medical Services.docx',
          text: 'Work Order for Medical services'
        },
        {
          key: 'Model Agency Services Manual',
          name: 'Model Agency Services Manual - 28 Nov 23.docx',
          text: 'Model Agency Services Manual'
        },
        {
          key: 'Provider Region Matrix',
          name: 'Provider Region Matrix.pdf',
          text: 'Provider Region Matrix'
        },
        {
          key: 'Notice of Inclusion',
          name: 'Notice of Inclusion.pdf',
          text: 'Notice of Inclusion'
        },
        {
          key: 'Personal Particulars Form',
          name: 'PersonalParticularsForm-ORAMSAnonymisedReferral.docx',
          text: 'Personal Particulars Form'
        },
      ]
    },
    {
      groupName: 'Portal guidance and procedures',
      documents: [
        {
          key: 'Privacy and Consent guidance',
          name: 'ORAMS Privacy and Consent guidance.pdf',
          text: 'Privacy and Consent guidance'
        },
        {
          key: 'Employee consent form (for the ORAMS Portal)',
          name: 'Employee Consent request form.pdf',
          text: 'Employee consent form (for the ORAMS Portal)'
        },
        {
          key: 'ORAMS Portal - Agency (RCM and Primary RCM) user functions and requirements',
          name: 'ORAMS - Agency (Primary RCM and RCM) user functions and requirements_Feb2024.pdf',
          text: 'ORAMS Portal - Agency (RCM and Primary RCM) user functions and requirements'
        },
      ]
    },
    {
      groupName: 'Portal Reporting Templates',
      subGroups: [
        {
          subGroupName: 'Reporting Templates',
          documents: [
            {
              key: '1. Offsite Assessment Report Template',
              name: 'ORAMS - Offsite Assessment Report template - 24 Nov 2023.docx',
              text: '1. Offsite Assessment Report Template'
            },
            {
              key: '2. Rehabilitation Assessment Report template - compensable',
              name: 'ORAMS - Rehabilitation Assessment (compensable) template - 24 Nov 2023.docx',
              text: '2. Rehabilitation Assessment Report template - compensable'
            },
            {
              key: '3. Rehabilitation Assessment Report template - non compensable',
              name: 'ORAMS - Rehabilitation Assessment (non-compensable) Report template - 24 Nov 2023.docx',
              text: '3. Rehabilitation Assessment Report template - non compensable'
            },
            {
              key: '4. Rehabilitation Program Closure Report Template - non compensable',
              name: 'ORAMS - Rehabilitation Program (Non-Compensable) Closure Report Template - 24 Nov 2023 .docx',
              text: '4. Rehabilitation Program Closure Report Template - non compensable'
            },
            {
              key: '5. Rehabilitation Program Progress Report Template',
              name: 'ORAMS - Rehabilitation Program Progress Report template - 24 Nov 2023.docx',
              text: '5. Rehabilitation Program Progress Report Template'
            },
            {
              key: '6. Rehabilitation Program Funding Request Template - non compensable',
              name: 'ORAMS - Rehabilitation Program (non-compensable) Funding Request template - 24 Nov 2023.docx',
              text: '6. Rehabilitation Program Funding Request Template - non compensable'
            },
          ]
        },
        {
          subGroupName: 'Off Portal Referral Forms',
          documents: [
            {
              key: 'Off-Portal Referral - Non-Compensable',
              name: 'Off-Portal Referral - Non-Compensable.pdf',
              text: 'Off-Portal Referral - Non-Compensable'
            },
            {
              key: 'Off-Portal Referral (Compensable) - With s36',
              name: 'Off-Portal Referral (Compensable) - With s36.pdf',
              text: 'Off-Portal Referral (Compensable) - With s36'
            },
            {
              key: 'Off-Portal Referral (compensable) - Without s36',
              name: 'Off-Portal Referral (Compensable) - Without s36.pdf',
              text: 'Off-Portal Referral (compensable) - Without s36'
            },
          ]
        }

      ]
    },
    {
      groupName: 'Meeting minutes',
      documents: [
        {
          key: 'Record of meeting log - Agency Quarterly Forum',
          name: 'Record of meeting log - Agency Quarterly Forum.docx',
          text: 'Record of meeting log - Agency Quarterly Forum'
        },
      ]
    },
  ],
  'primary-user': [
    {
      groupName: 'Operational documents',
      documents: [
        {
          key: 'Head Agreement for the provision of ORAMS (EXECUTED VERSION)',
          name: 'EXECUTION VERSION - Head Agreement for the provision of ORAMS.pdf',
          text: 'Head Agreement for the provision of ORAMS (EXECUTED VERSION)'
        },
        {
          key: 'Application of the Head Agreement - Questions and Answers for providers and agencies',
          name: 'Questions and Answers on the ORAMS Head Agreement.docx',
          text: 'Application of the Head Agreement - Questions and Answers for providers and agencies'
        },
        {
          key: 'ORAMS Service Requirements',
          name: 'Service Requirements .pdf',
          text: 'ORAMS Service Requirements'
        },
        {
          key: 'Universal Operations Manual',
          name: 'UOM Manual WORD FINAL.docx',
          text: 'Universal Operations Manual'
        },
        {
          key: 'Work Order for Rehabilitation services',
          name: 'Work Order - Rehabilitation Services.docx',
          text: 'Work Order for Rehabilitation services'
        },
        {
          key: 'Work Order for Medical services',
          name: 'Work Order - Medical Services.docx',
          text: 'Work Order for Medical services'
        },
        {
          key: 'Model Agency Services Manual',
          name: 'Model Agency Services Manual - 28 Nov 23.docx',
          text: 'Model Agency Services Manual'
        },
        {
          key: 'Provider Region Matrix',
          name: 'Provider Region Matrix.pdf',
          text: 'Provider Region Matrix'
        },
        {
          key: 'Notice of Inclusion',
          name: 'Notice of Inclusion.pdf',
          text: 'Notice of Inclusion'
        },
        {
          key: 'Personal Particulars Form',
          name: 'PersonalParticularsForm-ORAMSAnonymisedReferral.docx',
          text: 'Personal Particulars Form'
        },
      ]
    },
    {
      groupName: 'Portal guidance and procedures',
      documents: [
        {
          key: 'Privacy and Consent guidance',
          name: 'ORAMS Privacy and Consent guidance.pdf',
          text: 'Privacy and Consent guidance'
        },
        {
          key: 'Employee consent form (for the ORAMS Portal)',
          name: 'Employee Consent request form.pdf',
          text: 'Employee consent form (for the ORAMS Portal)'
        },
        {
          key: 'ORAMS Portal - Agency (RCM and Primary RCM) user functions and requirements',
          name: 'ORAMS - Agency (Primary RCM and RCM) user functions and requirements_Feb2024.pdf',
          text: 'ORAMS Portal - Agency (RCM and Primary RCM) user functions and requirements'
        },
      ]
    },
    {
      groupName: 'Portal Reporting Templates',
      subGroups: [
        {
          subGroupName: 'Reporting Templates',
          documents: [
            {
              key: '1. Offsite Assessment Report Template',
              name: 'ORAMS - Offsite Assessment Report template - 24 Nov 2023.docx',
              text: '1. Offsite Assessment Report Template'
            },
            {
              key: '2. Rehabilitation Assessment Report template - compensable',
              name: 'ORAMS - Rehabilitation Assessment (compensable) template - 24 Nov 2023.docx',
              text: '2. Rehabilitation Assessment Report template - compensable'
            },
            {
              key: '3. Rehabilitation Assessment Report template - non compensable',
              name: 'ORAMS - Rehabilitation Assessment (non-compensable) Report template - 24 Nov 2023.docx',
              text: '3. Rehabilitation Assessment Report template - non compensable'
            },
            {
              key: '4. Rehabilitation Program Closure Report Template - non compensable',
              name: 'ORAMS - Rehabilitation Program (Non-Compensable) Closure Report Template - 24 Nov 2023 .docx',
              text: '4. Rehabilitation Program Closure Report Template - non compensable'
            },
            {
              key: '5. Rehabilitation Program Progress Report Template',
              name: 'ORAMS - Rehabilitation Program Progress Report template - 24 Nov 2023.docx',
              text: '5. Rehabilitation Program Progress Report Template'
            },
            {
              key: '6. Rehabilitation Program Funding Request Template - non compensable',
              name: 'ORAMS - Rehabilitation Program (non-compensable) Funding Request template - 24 Nov 2023.docx',
              text: '6. Rehabilitation Program Funding Request Template - non compensable'
            },
          ]
        },
        {
          subGroupName: 'Off Portal Referral Forms',
          documents: [
            {
              key: 'Off-Portal Referral - Non-Compensable',
              name: 'Off-Portal Referral - Non-Compensable.pdf',
              text: 'Off-Portal Referral - Non-Compensable'
            },
            {
              key: 'Off-Portal Referral (Compensable) - With s36',
              name: 'Off-Portal Referral (Compensable) - With s36.pdf',
              text: 'Off-Portal Referral (Compensable) - With s36'
            },
            {
              key: 'Off-Portal Referral (compensable) - Without s36',
              name: 'Off-Portal Referral (Compensable) - Without s36.pdf',
              text: 'Off-Portal Referral (compensable) - Without s36'
            },
          ]
        }
      ]
    },
    {
      groupName: 'Meeting minutes',
      documents: [
        {
          key: 'Record of meeting log - Agency Quarterly Forum',
          name: 'Record of meeting log - Agency Quarterly Forum.docx',
          text: 'Record of meeting log - Agency Quarterly Forum'
        },
      ]
    },
  ],
  supplier: [
    {
      groupName: 'Operational documents',
      documents: [
        {
          key: 'Head Agreement for the provision of ORAMS (EXECUTED VERSION)',
          name: 'EXECUTION VERSION - Head Agreement for the provision of ORAMS.pdf',
          text: 'Head Agreement for the provision of ORAMS (EXECUTED VERSION)'
        },
        {
          key: 'Application of the Head Agreement - Questions and Answers for providers and agencies',
          name: 'Questions and Answers on the ORAMS Head Agreement.docx',
          text: 'Application of the Head Agreement - Questions and Answers for providers and agencies'
        },
        {
          key: 'ORAMS Service Requirements',
          name: 'Service Requirements .pdf',
          text: 'ORAMS Service Requirements'
        },
        {
          key: 'Universal Operations Manual',
          name: 'UOM Manual WORD FINAL.docx',
          text: 'Universal Operations Manual'
        },
        {
          key: 'Work Order for Rehabilitation services',
          name: 'Work Order - Rehabilitation Services.docx',
          text: 'Work Order for Rehabilitation services'
        },
        {
          key: 'Work Order for Medical services',
          name: 'Work Order - Medical Services.docx',
          text: 'Work Order for Medical services'
        },
      ]
    },
    {
      groupName: 'Portal guidance and procedures',
      documents: [
        {
          key: 'ORAMS Portal - Provider user functions and requirements',
          name: 'ORAMS - Provider user functions and requirements_Jan2024.pdf',
          text: 'ORAMS Portal - Provider user functions and requirements'
        },
        {
          key: 'Invoice Datasheet template',
          name: 'Invoice Datasheet Template.xlsx',
          text: 'Invoice Datasheet template'
        },
      ]
    },
    {
      groupName: 'Portal Reporting Templates',
      subGroups: [
        {
          subGroupName: 'Reporting Templates',
          documents: [
            {
              key: '1. Offsite Assessment Report Template',
              name: 'ORAMS - Offsite Assessment Report template - 24 Nov 2023.docx',
              text: '1. Offsite Assessment Report Template'
            },
            {
              key: '2. Rehabilitation Assessment Report template - compensable',
              name: 'ORAMS - Rehabilitation Assessment (compensable) template - 24 Nov 2023.docx',
              text: '2. Rehabilitation Assessment Report template - compensable'
            },
            {
              key: '3. Rehabilitation Assessment Report template - non compensable',
              name: 'ORAMS - Rehabilitation Assessment (non-compensable) Report template - 24 Nov 2023.docx',
              text: '3. Rehabilitation Assessment Report template - non compensable'
            },
            {
              key: '4. Rehabilitation Program Closure Report Template - non compensable',
              name: 'ORAMS - Rehabilitation Program (Non-Compensable) Closure Report Template - 24 Nov 2023 .docx',
              text: '4. Rehabilitation Program Closure Report Template - non compensable'
            },
            {
              key: '5. Rehabilitation Program Progress Report Template',
              name: 'ORAMS - Rehabilitation Program Progress Report template - 24 Nov 2023.docx',
              text: '5. Rehabilitation Program Progress Report Template'
            },
            {
              key: '6. Rehabilitation Program Funding Request Template - non compensable',
              name: 'ORAMS - Rehabilitation Program (non-compensable) Funding Request template - 24 Nov 2023.docx',
              text: '6. Rehabilitation Program Funding Request Template - non compensable'
            },
          ]
        },
        {
          subGroupName: 'Off Portal Referral Forms',
          documents: [
            {
              key: 'Off-Portal Referral - Non-Compensable',
              name: 'Off-Portal Referral - Non-Compensable.pdf',
              text: 'Off-Portal Referral - Non-Compensable'
            },
            {
              key: 'Off-Portal Referral (Compensable) - With s36',
              name: 'Off-Portal Referral (Compensable) - With s36.pdf',
              text: 'Off-Portal Referral (Compensable) - With s36'
            },
            {
              key: 'Off-Portal Referral (compensable) - Without s36',
              name: 'Off-Portal Referral (Compensable) - Without s36.pdf',
              text: 'Off-Portal Referral (compensable) - Without s36'
            },
          ]
        }
      ],
    },
    {
      groupName: 'Quarterly data reporting templates',
      documents: [
        {
          key: 'ORAMS Provider activity statement_Rehabiliation Services',
          name: 'ORAMS Provider Activity Statement_Rehab.xlsx',
          text: 'ORAMS Provider activity statement_Rehabiliation Services'
        },
        {
          key: 'ORAMS Provider activity statement_Medical Services',
          name: 'ORAMS Provider Activity Statement_Medical.xlsx',
          text: 'ORAMS Provider activity statement_Medical Services'
        },
        {
          key: 'ORAMS panel activity statement_Rehabilitation Services',
          name: 'ORAMS Panel Activity Statement_Rehabilitation services.xlsx',
          text: 'ORAMS panel activity statement_Rehabilitation Services'
        },
        {
          key: 'ORAMS panel activity statement_Medical Services',
          name: 'ORAMS Panel Activity Statement_Medical services.xlsx',
          text: 'ORAMS panel activity statement_Medical Services'
        },
      ]
    },
    {
      groupName: 'Meeting minutes',
      documents: [
        {
          key: 'Record of meeting log - Provider Quarterly Forum',
          name: 'Record of meeting log - Provider Quarterly Forum.docx',
          text: 'Record of meeting log - Provider Quarterly Forum'
        },
      ]
    },
  ],
  admin: [
    {
      groupName: 'Operational documents',
      documents: [
        {
          key: 'Head Agreement for the provision of ORAMS (EXECUTED VERSION)',
          name: 'EXECUTION VERSION - Head Agreement for the provision of ORAMS.pdf',
          text: 'Head Agreement for the provision of ORAMS (EXECUTED VERSION)'
        },
        {
          key: 'Application of the Head Agreement - Questions and Answers for providers and agencies',
          name: 'Questions and Answers on the ORAMS Head Agreement.docx',
          text: 'Application of the Head Agreement - Questions and Answers for providers and agencies'
        },
        {
          key: 'ORAMS Service Requirements',
          name: 'Service Requirements .pdf',
          text: 'ORAMS Service Requirements'
        },
        {
          key: 'Universal Operations Manual',
          name: 'UOM Manual WORD FINAL.docx',
          text: 'Universal Operations Manual'
        },
        {
          key: 'Work Order for Rehabilitation services',
          name: 'Work Order - Rehabilitation Services.docx',
          text: 'Work Order for Rehabilitation services'
        },
        {
          key: 'Work Order for Medical services',
          name: 'Work Order - Medical Services.docx',
          text: 'Work Order for Medical services'
        },
        {
          key: 'Model Agency Services Manual',
          name: 'Model Agency Services Manual - 28 Nov 23.docx',
          text: 'Model Agency Services Manual'
        },
        {
          key: 'Provider Region Matrix',
          name: 'Provider Region Matrix.pdf',
          text: 'Provider Region Matrix'
        },
        {
          key: 'Notice of Inclusion',
          name: 'Notice of Inclusion.pdf',
          text: 'Notice of Inclusion'
        },
        {
          key: 'Personal Particulars Form',
          name: 'PersonalParticularsForm-ORAMSAnonymisedReferral.docx',
          text: 'Personal Particulars Form'
        },
      ]
    },
    {
      groupName: 'Portal guidance and procedures',
      documents: [
        {
          key: 'Privacy and Consent guidance',
          name: 'ORAMS Privacy and Consent guidance.pdf',
          text: 'Privacy and Consent guidance'
        },
        {
          key: 'Employee consent form (for the ORAMS Portal)',
          name: 'Employee Consent request form.pdf',
          text: 'Employee consent form (for the ORAMS Portal)'
        },
        {
          key: 'ORAMS Portal - Agency (RCM and Primary RCM) user functions and requirements',
          name: 'ORAMS - Agency (Primary RCM and RCM) user functions and requirements_Feb2024.pdf',
          text: 'ORAMS Portal - Agency (RCM and Primary RCM) user functions and requirements'
        },
        {
          key: 'ORAMS Portal - Provider user functions and requirements',
          name: 'ORAMS - Provider user functions and requirements_Jan2024.pdf',
          text: 'ORAMS Portal - Provider user functions and requirements'
        },
        {
          key: 'Invoice Datasheet template',
          name: 'Invoice Datasheet Template.xlsx',
          text: 'Invoice Datasheet template'
        },
      ]
    },
    {
      groupName: 'Portal Reporting Templates',
      subGroups: [
        {
          subGroupName: 'Reporting Templates',
          documents: [
            {
              key: '1. Offsite Assessment Report Template',
              name: 'ORAMS - Offsite Assessment Report template - 24 Nov 2023.docx',
              text: '1. Offsite Assessment Report Template'
            },
            {
              key: '2. Rehabilitation Assessment Report template - compensable',
              name: 'ORAMS - Rehabilitation Assessment (compensable) template - 24 Nov 2023.docx',
              text: '2. Rehabilitation Assessment Report template - compensable'
            },
            {
              key: '3. Rehabilitation Assessment Report template - non compensable',
              name: 'ORAMS - Rehabilitation Assessment (non-compensable) Report template - 24 Nov 2023.docx',
              text: '3. Rehabilitation Assessment Report template - non compensable'
            },
            {
              key: '4. Rehabilitation Program Closure Report Template - non compensable',
              name: 'ORAMS - Rehabilitation Program (Non-Compensable) Closure Report Template - 24 Nov 2023 .docx',
              text: '4. Rehabilitation Program Closure Report Template - non compensable'
            },
            {
              key: '5. Rehabilitation Program Progress Report Template',
              name: 'ORAMS - Rehabilitation Program Progress Report template - 24 Nov 2023.docx',
              text: '5. Rehabilitation Program Progress Report Template'
            },
            {
              key: '6. Rehabilitation Program Funding Request Template - non compensable',
              name: 'ORAMS - Rehabilitation Program (non-compensable) Funding Request template - 24 Nov 2023.docx',
              text: '6. Rehabilitation Program Funding Request Template - non compensable'
            },
          ]
        },
        {
          subGroupName: 'Off Portal Referral Forms',
          documents: [
            {
              key: 'Off-Portal Referral - Non-Compensable',
              name: 'Off-Portal Referral - Non-Compensable.pdf',
              text: 'Off-Portal Referral - Non-Compensable'
            },
            {
              key: 'Off-Portal Referral (Compensable) - With s36',
              name: 'Off-Portal Referral (Compensable) - With s36.pdf',
              text: 'Off-Portal Referral (Compensable) - With s36'
            },
            {
              key: 'Off-Portal Referral (compensable) - Without s36',
              name: 'Off-Portal Referral (Compensable) - Without s36.pdf',
              text: 'Off-Portal Referral (compensable) - Without s36'
            },
          ]
        }
      ]
    },
    {
      groupName: 'Quarterly data reporting templates',
      documents: [
        {
          key: 'ORAMS Provider activity statement_Rehabiliation Services',
          name: 'ORAMS Provider Activity Statement_Rehab.xlsx',
          text: 'ORAMS Provider activity statement_Rehabiliation Services'
        },
        {
          key: 'ORAMS Provider activity statement_Medical Services',
          name: 'ORAMS Provider Activity Statement_Medical.xlsx',
          text: 'ORAMS Provider activity statement_Medical Services'
        },
        {
          key: 'ORAMS panel activity statement_Rehabilitation Services',
          name: 'ORAMS Panel Activity Statement_Rehabilitation services.xlsx',
          text: 'ORAMS panel activity statement_Rehabilitation Services'
        },
        {
          key: 'ORAMS panel activity statement_Medical Services',
          name: 'ORAMS Panel Activity Statement_Medical services.xlsx',
          text: 'ORAMS panel activity statement_Medical Services'
        },
      ]
    },
    {
      groupName: 'Meeting minutes',
      documents: [
        {
          key: 'Record of meeting log - Provider Quarterly Forum',
          name: 'Record of meeting log - Provider Quarterly Forum.docx',
          text: 'Record of meeting log - Provider Quarterly Forum'
        },
        {
          key: 'Record of meeting log - Agency Quarterly Forum',
          name: 'Record of meeting log - Agency Quarterly Forum.docx',
          text: 'Record of meeting log - Agency Quarterly Forum'
        },
      ]
    },
  ]
}

export function getDocumentUrl(documentName) {
  return `${API}/${documentName}?${QUERY}`;
}

export default function useDocument() {
    const { user } = useAuth();

    let userDocuments = [];

    if (user && user.token) {
        if (user.role) {
            userDocuments = documentsMap[user.role];
        }
    }

    return { userDocuments, getDocumentUrl };
};